export default {
  'get-list': {
    method: 'post',
    url: '/ws-admincp/vehicle/category/list'
  },
  getAll: {
    method: 'post',
    url: '/ws-admincp/vehicle/category/get-all'
  },
  getAllList: {
    method: 'get',
    url: '/ws-admincp/vehicle/category/list'
  },
  add: {
    method: 'post',
    url: '/ws-admincp/vehicle/category'
  },
  delete: {
    url: '/ws-admincp/vehicle/category',
    method: 'delete'
  },
  archive: {
    url: '/ws-admincp/vehicle/category/archive',
    method: 'delete'
  },
  restore: {
    url: '/ws-admincp/vehicle/category/restore',
    method: 'put'
  },
  getById: {
    url: '/ws-admincp/vehicle/category/ID',
    method: 'get'
  },
  edit: {
    url: '/ws-admincp/vehicle/category/ID',
    method: 'put'
  },
  find: {
    method: 'get',
    url: '/ws-admincp/vehicle/category/find'
  },
  'find-by-vehicle-tonnage': {
    method: 'get',
    url: '/ws-admincp/vehicle/category/find-by-vehicle-tonnage?key=KEY'
  },
  lastCategory: {
    method: 'get',
    url: '/ws-admincp/vehicle/category/last-category'
  }
}
